import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';

const DetailsSection = ({ detail }) => {
    return (
        <React.Fragment>
            <Col xl={8}>
                {/* 1. ROTA KARTI */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <div className="bg-dark text-white px-3 py-1 rounded-pill d-inline-block mb-4 fw-medium">
                            Rota {detail.distance} - {detail.duration}
                        </div>
                        
                        <Row>
                            <Col md={6} className="border-end border-light">
                                <div className="d-flex mb-3">
                                    <div className="me-2 fs-5">{detail.start.countryFlag}</div>
                                    <div>
                                        <h5 className="mb-1 fw-bold">{detail.start.city}</h5>
                                        <p className="text-muted mb-3">{detail.start.date}</p>
                                        
                                        <h6 className="text-muted text-uppercase fs-12 mb-1">ADRES</h6>
                                        <p className="mb-2 text-dark" style={{ whiteSpace: "pre-wrap" }}>
                                            {detail.start.address}
                                        </p>
                                        <Link to="#" className="text-dark text-decoration-underline fw-medium">Ayrıntıları görün</Link>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6} className="ps-md-4">
                                <div className="d-flex mb-3">
                                    <div className="me-2 fs-5">{detail.end.countryFlag}</div>
                                    <div>
                                        <h5 className="mb-1 fw-bold">{detail.end.city}</h5>
                                        <p className="text-muted mb-3">{detail.end.date}</p>
                                        
                                        <h6 className="text-muted text-uppercase fs-12 mb-1">ADRES</h6>
                                        <p className="mb-2 text-dark" style={{ whiteSpace: "pre-wrap" }}>
                                            {detail.end.address}
                                        </p>
                                        <Link to="#" className="text-dark text-decoration-underline fw-medium">Ayrıntıları görün</Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="bg-light text-dark p-3 rounded mt-4 d-flex justify-content-between align-items-center" style={{cursor: 'pointer'}}>
                            <div>
                                <span className="fw-bold me-2">? Yardım</span> 
                                Ulaşım ve yol maliyetlerinin hesaplanmasını kolaylaştırmak için ulaşım seçeneklerinizi keşfedin
                            </div>
                            <i className="mdi mdi-chevron-right fs-4"></i>
                        </div>
                    </CardBody>
                </Card>

                {/* 2. ARAÇ KARTI */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <div className="bg-dark text-white px-3 py-1 rounded-pill d-inline-block mb-4 fw-medium">
                            Araç
                        </div>
                        
                        <Row>
                            <Col md={6} className="border-end border-light">
                                <h6 className="d-flex align-items-center mb-4 text-dark fw-bold">
                                    <i className="mdi mdi-car me-2 fs-4 text-primary"></i> Araç tipi
                                </h6>
                                <Row>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MARKA</p>
                                        <h6 className="fw-bold">{detail.vehicle.brand}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MODEL</p>
                                        <h6 className="fw-bold">{detail.vehicle.model}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">Motorizasyon</p>
                                        <h6 className="fw-bold">{detail.vehicle.engine}</h6>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6} className="ps-md-4">
                                <h6 className="d-flex align-items-center mb-4 text-dark fw-bold">
                                    <i className="mdi mdi-gas-station me-2 fs-4 text-primary"></i> Yakıt
                                </h6>
                                <Row>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">YAKIT TÜRÜ</p>
                                        <h6 className="fw-bold">{detail.vehicle.fuelType}</h6>
                                    </Col>
                                    <Col xs={8}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">TALİMATLAR</p>
                                        <p className="mb-0 fs-13">{detail.vehicle.instructions}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <div className="bg-light text-dark p-3 rounded mt-4 d-flex justify-content-between align-items-center" style={{cursor: 'pointer'}}>
                            <div>
                                <span className="fw-bold me-2">? Yardım</span> 
                                Ulaşım ve yol maliyetlerinin hesaplanmasını kolaylaştırmak için ulaşım seçeneklerinizi keşfedin
                            </div>
                            <i className="mdi mdi-chevron-right fs-4"></i>
                        </div>
                    </CardBody>
                </Card>

                {/* 3. ULAŞIM DETAYLARI KARTI */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <div className="bg-dark text-white px-3 py-1 rounded-pill d-inline-block mb-4 fw-medium">
                            Ulaşım detayları
                        </div>
                        
                        <Row className="gy-4">
                            <Col md={6}>
                                <h6 className="d-flex align-items-center mb-3 fw-bold">
                                    <i className="mdi mdi-cog-outline me-2 text-primary fs-5"></i> Tamamlayıcı hizmetler
                                </h6>
                                <ul className="list-unstyled mb-0">
                                    {detail.services.map((service, index) => (
                                        <li key={index} className="mb-2 d-flex align-items-start">
                                            <i className="mdi mdi-check text-success me-2 mt-1"></i> {service}
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                            <Col md={6}>
                                <h6 className="d-flex align-items-center mb-3 fw-bold">
                                    <i className="mdi mdi-clipboard-text-outline me-2 text-primary fs-5"></i> Taşıma prosedürü
                                </h6>
                                <p className="mb-0"><strong>Teslimat</strong><br/>{detail.procedure}</p>
                            </Col>
                            
                            <Col md={6}>
                                <h6 className="d-flex align-items-center mb-3 fw-bold">
                                    <i className="mdi mdi-comment-processing-outline me-2 text-primary fs-5"></i> Müşteri yorumları
                                </h6>
                                <p className="mb-0 fst-italic text-muted">{detail.comments}</p>
                            </Col>
                            <Col md={6}>
                                <h6 className="d-flex align-items-center mb-3 fw-bold">
                                    <i className="mdi mdi-text-box-outline me-2 text-primary fs-5"></i> Müşteri talimatları
                                </h6>
                                <Link to="#" className="text-primary">{detail.customerInstructions}</Link>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default DetailsSection;